const ResellerStatsPermissions = {
  RESELLER_STATS_READ: 'reseller_stats_read',
};

export default ResellerStatsPermissions;
